import { useEffect } from 'react';

const LoginPage = () => {
  const handleLogin = () => {
    window.location.href = '/auth/login';
  };

  useEffect(() => {
    document.getElementsByClassName('ui-loader-container')[0]?.remove();
  }, []);

  return (
    <div className="page-container">
      <div className="centered-content">
        <div className="ollama-logo">🦙</div>
        <h1 className="login-title">Welcome to Ollama</h1>
        <p className="login-subtitle">Please sign in to continue</p>
        <button className="google-login-btn" onClick={handleLogin}>
          <div className="google-icon">G</div>
          Continue with Google
        </button>
      </div>
    </div>
  );
};

export default LoginPage;